<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 24 24"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M12 13.661c-1.786 0-3.239-1.466-3.239-3.27 0-1.802 1.453-3.268 3.239-3.268 1.787 0 3.24 1.466 3.24 3.268 0 1.804-1.453 3.27-3.24 3.27m11.793-3.312C21.06 6.374 16.651 4 12 4 7.349 4 2.941 6.374.207 10.35c-.365.53-.234 1.259.29 1.627.527.37 1.249.236 1.614-.294a12.408 12.408 0 0 1 5.238-4.34 5.603 5.603 0 0 0-.905 3.048C6.444 13.484 8.936 16 12 16c3.065 0 5.557-2.516 5.557-5.609a5.599 5.599 0 0 0-.905-3.047 12.41 12.41 0 0 1 5.237 4.34 1.156 1.156 0 0 0 1.613.293 1.177 1.177 0 0 0 .291-1.628"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
